import { axios } from '@/utils/request'
import { passwordEncryption } from '@/utils/util'
import _ from 'lodash'

const api = {
  UserInfo: '/teacher.php/User/getInfo',
  Logout: '/teacher.php/User/logout',
  Login: '/teacher.php/User/login',
  MenuList: '/teacher.php/User/getMenu',
  updatePasswd: '/teacher.php/User/updatePasswd',
  TeacherDetail: '/teacher.php/User/getTeacherDetail',
  SaveTeacher: '/teacher.php/User/saveTeacher'
}

export function login (tenantCode, account, password, code) {
  const pwdEncrypt = passwordEncryption(password)
  return axios({
    url: api.Login,
    method: 'post',
    data: {
      tenantCode,
      account,
      code,
      password: pwdEncrypt
    }
  })
}

export function logout () {
  return axios({
    url: api.Logout,
    method: 'post'
  })
}

export function getUserInfo () {
  return axios({
    url: api.UserInfo,
    method: 'get'
  })
}

export function getUserPermission () {
  return axios({
    url: api.MenuList,
    method: 'get'
  })
    .then(res => {
      // 将权限表序列化
      if (_.get(res, 'code') === 200) {
        // return _.get(res, 'data', [])
        return _.map(_.get(res, 'data', []), res => res.auth_path)
      }
      return res
    })
}

export function updatePasswd (data) {
  return axios({
    url: api.updatePasswd,
    method: 'post',
    data: data
  })
}

export function teacherDetail () {
  return axios({
    url: api.TeacherDetail,
    method: 'get'
  })
}

export function saveTeacher (data) {
  return axios({
    url: api.SaveTeacher,
    method: 'post',
    data: data
  })
}